import { createReducer, on } from '@ngrx/store';
import { ToEntities } from '@teamfoster/sdk/array-utility';
import { MuseumCollection } from '../../models';
import * as actions from '../actions/museum-collections.action';

export interface MuseumCollectionsState {
  entities: { [id: number]: MuseumCollection };
  loaded: number[];
  loading: number[];
  overviewLoaded: boolean;
  overviewLoading: boolean;
  error?: any;
}

export const initialState: MuseumCollectionsState = {
  entities: {},
  loaded: [],
  loading: [],
  overviewLoaded: false,
  overviewLoading: false,
};

export const MuseumCollectionReducer = createReducer(
  initialState,
  on(actions.LoadMuseumCollections, (state: MuseumCollectionsState) => {
    return {
      ...state,
      overviewLoading: true,
    };
  }),
  on(actions.LoadMuseumCollectionsSuccess, (state: MuseumCollectionsState, { collections }) => {
    const entities = ToEntities(collections, 'id', state.entities);
    return {
      ...state,
      entities,
      overviewLoading: false,
      overviewLoaded: true,
      loaded: collections.map(c => c.id),
    };
  }),
  on(actions.LoadMuseumCollectionsFail, (state: MuseumCollectionsState, { error }) => {
    return {
      ...state,
      overviewLoading: false,
      overviewLoaded: false,
      error,
    };
  }),
  on(actions.LoadMuseumCollectionById, (state: MuseumCollectionsState, { id }) => {
    return {
      ...state,
      loading: [...state.loading, id],
    };
  }),
  on(actions.LoadMuseumCollectionByIdSuccess, (state: MuseumCollectionsState, { collection }) => {
    const entities = { ...state.entities, [collection.id]: collection };
    return {
      ...state,
      entities,
      loading: state.loading.filter(id => id !== collection.id),
      loaded: [...state.loaded, collection.id],
    };
  }),
  on(actions.LoadMuseumCollectionByIdFail, (state: MuseumCollectionsState, { error, id }) => {
    return {
      ...state,
      loading: state.loading.filter(id => id !== id),
      loaded: state.loaded.filter(id => id !== id),
      error,
    };
  })
);

export const getMuseumCollectionsEntities = (state: MuseumCollectionsState) => state.entities;
export const getMuseumCollectionsLoading = (state: MuseumCollectionsState) => state.loading;
export const getMuseumCollectionsLoaded = (state: MuseumCollectionsState) => state.loaded;
export const getMuseumCollectionsOverviewLoading = (state: MuseumCollectionsState) => state.overviewLoading;
export const getMuseumCollectionsOverviewLoaded = (state: MuseumCollectionsState) => state.overviewLoaded;
